module.exports = __webpack_public_path__ + "account/assets/qr-code-icon.30c3e86d.svg";